// SelectWidget.tsx
import React from 'react';
import { MenuItem, TextField, Box, Typography, Skeleton } from '@mui/material';


export interface Option {
  value: string | number;
  label: string;
}

// Типизируем пропсы через Generic <T>, чтобы поле 'field' 
// соответствовало ключам объекта
interface SelectWidgetProps<T> {
  object: T;
  field: keyof T;
  options: Option[];
  onSave: (field: string, value: any) => Promise<void> | void;
  label?: string;
  title?: string;
}

export const SelectWidget = <T,>({
  object,
  field,
  options,
  onSave,
  label,
  title,
}: SelectWidgetProps<T>) => {
  const [value, setValue] = React.useState(String(object?.[field] ?? ''));
  const [loading, setLoading] = React.useState(false);

// Добавьте этот эффект для синхронизации данных при их загрузке
  React.useEffect(() => {
    if (object && object[field] !== undefined) {
      setValue(String(object[field]));
    }
  }, [object, field]); // Следим за изменением объекта

  if (!object) {
    // return null; // Or a <Skeleton /> / <CircularProgress />
    return <Skeleton />
  }

  // const currentValue = object[field]; // извлекаем примитив
  // React.useEffect(() => {
  //   setValue(String(currentValue || ''));
  // }, [currentValue]);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = event.target.value;
    setValue(newVal);
    
    setLoading(true);
    try {
      await onSave(field as string, newVal);
    } catch (error) {
      console.error("Failed to save:", error);
      // При ошибке можно откатить значение к исходному
      setValue(String(object[field]));
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (newVal: string) => {
    setValue(newVal);
    
    setLoading(true);
    try {
      await onSave(field as string, newVal);
    } catch (error) {
      console.error("Failed to save:", error);
      // При ошибке можно откатить значение к исходному
      setValue(String(object[field]));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minWidth: 120, my: 1 }}>
        {title && (
        <Typography variant="h6" sx={{ mb: 1, /*fontWeight: 'bold'*/ }}>
            {title}
        </Typography>
        )}
        <TextField
            select
            // fullWidth
            label={label}
            value={value}
            disabled={loading}
            onChange={handleChange}
            variant="outlined"
            size="small"
        >
            {options.map((option) => (
            <MenuItem key={option.value} value={option.value} onClick={() => handleClick(option.value as string)}>
                {option.label}
            </MenuItem>
            ))}
        </TextField>
    </Box>
  );
};